import { Tool } from "@/types/tool";
import { Button } from "@/components/ui/button";
import { ExternalLink, PhoneCall } from "lucide-react";

interface ToolCardActionsProps {
  tool: Tool;
}

const ToolCardActions = ({ tool }: ToolCardActionsProps) => {
  return (
    <div className="flex gap-2">
      {tool.business_phone && (
        <Button
          variant="outline"
          size="sm"
          className="flex-1 text-green-600 border-green-200 hover:bg-green-50 shadow-sm"
          onClick={() => window.location.href = `tel:${tool.business_phone}`}
        >
          <PhoneCall className="w-4 h-4 mr-1.5" />
          Call
        </Button>
      )}
      <Button
        variant="outline"
        size="sm"
        className="flex-1 text-purple-600 border-purple-200 hover:bg-purple-50 shadow-sm"
        onClick={() => window.open(tool.visitUrl, '_blank')}
      >
        <ExternalLink className="w-4 h-4 mr-1.5" />
        Visit Website
      </Button>
    </div>
  );
};

export default ToolCardActions;